import { Theme } from '@mui/material';

export const Styles = (theme: Theme) => {
  return {
    gridContainer: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gridTemplateRows: 'repeat(3, auto)',
      width: theme.custom.width['100%'],
      height: theme.custom.height['100%'],
      gap: '0',
      padding: '0',
    },
  };
};
